import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';

import RouterWrapper from '@/utils/RouterWrapper';

import { ReactComponent as NoBookingsIcon } from '@/img/bookings/no-bookings-yet.svg';

const NoBookingsYet = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    
    const handleClick = () => {
        RouterWrapper.goToSearchPage(navigate);
    }

    return (
        <div className="no-bookings-yet">
            <NoBookingsIcon />
            <div className="no-bookings-yet__content">
                <div className="no-bookings-yet__title">{t('NoBookingsYet.Title')}</div>
                <div className="no-bookings-yet__message">
                    {t('NoBookingsYet.Message')}
                    <br />
                    {t('NoBookingsYet.Cta')}
                </div>
                <Button variant="contained" className="no-bookings-yet__button" onClick={handleClick}>
                    {t('NoBookingsYet.BookNow')}
                </Button>
            </div>
        </div>
    );
};

export default NoBookingsYet;